import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en/translation.json";

const languageDetector = new LanguageDetector();

languageDetector.addDetector({
    name: 'customDetector',
    lookup() {
        return 'en';
    }
});

const detectionOptions = {
    caches: ['cookie'],
    cookieSameSite: 'strict',
    lookupQuerystring: 'lang', // default is lng
    lookupCookie: 'next-i18next',
    order: ['querystring', 'customDetector', 'cookie', 'header'], // IMPORTANT
}

const resources = {
    en
}

i18n
.use(initReactI18next)
.use(languageDetector)
.init({
    resources,
    detection: detectionOptions,
    defaultNS: "common",
    fallbackLng: "en",
});